import script from "./EnviosView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnviosView.vue?vue&type=script&setup=true&lang=ts"

import "./EnviosView.vue?vue&type=style&index=0&id=7c210450&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c210450"]])

export default __exports__